import { useState } from 'react';
import { ServerResponse } from '../services/qbeService';

const useValidate = (userData: (values: object) => void, onComplete: (values: object) => void) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ServerResponse | undefined>(undefined);

  const parseError = (error: Error) => {
    try {
      return JSON.parse(error.message);
    } catch (error) {
      return null;
    }
  };

  const executeRequest = async (values: object) => {
    setLoading(true);
    try {
      await userData(values);
      setLoading(false);
      return onComplete(values);
    } catch (error) {
      setError(parseError(error as Error));
    } finally {
      setLoading(false);
    }
  };

  return { executeRequest, loading, error };
};

export { useValidate };
